import React, { useEffect, useRef, useState } from 'react'
import useModal from '../../../../utils/hooks/useModal'
import ModalMenu from '../../../../containers/ModalMenu'
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { setProductToTranfer, addToTranferCart, setQuantityToTranfer, createPendingOrders, getConsolidateProducts } from '../../../actions/transferActions';
import { isNumeric } from '../../../../utils/functions';
import { getAllWareHouses } from '../../../actions/wareHouseActions';
import { listSubWineries } from '../../../actions/subWineryActions';
import { Table } from "../../Table/Table";
import { getProductsById } from '../../../actions/productActions';
import { AddList } from '../../../../assets/icons';
import plusCircle from '../../../../assets/img/plusCircle.png';
import style from './Transfer.module.css';
import buttonStyle from './ButtonStyle.module.css';
import modalStyle from './ModalTransfer.module.css';
import tableStyle from './Table.module.css';
import Input from '../../../../utils/components/Input/Input';
import ButtonIcon from '../../../../utils/components/ButtonIcon/ButtonIcon';


const CreateTranferWithoutOrder = () => {
    const [refAdd, isShowAdd, setIsShowAdd] = useModal(false)
    const [destiny, setDestiny] = useState(null)
    const [originId, setOriginId] = useState("inventory")
    const [destinyId, setDestinyId] = useState(null)
    const [isVisibleIconCart, setIsVisibleIconCart] = useState(false);
    const saleCartRef = useRef();

    useEffect(() => {
        if (saleCartRef.current) {
            saleCartRef.current.scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest'
                })
        }
    }, [isVisibleIconCart])

    const { wineriesList } = useSelector((state) => state.wineriesAdmin);
    const { subWineriesList } = useSelector((state) => state.subWineries);
    const { consolidateProducts } = useSelector((state) => state.tranfers);
    const { productsList } = useSelector((state) => state.productsList);
    const { wareHouseList } = useSelector((state) => state.WareHouse);
    const dispatch = useDispatch()
    let inventory = []
    if (originId ==="inventory") {
        inventory = consolidateProducts
        //dispatch(getConsolidateProducts());
    } else if (originId) {
        inventory = productsList
        //    dispatch(getProductsById(originId))
    }

    useEffect(() => {
        if (originId ==="inventory") {
            inventory = consolidateProducts
            dispatch(getConsolidateProducts(0, '', "","",100));
        } else if (originId) {
            inventory = productsList
            dispatch(getProductsById(originId))
        }
    }, [originId])
    useEffect(() => {
        dispatch(getAllWareHouses());
        dispatch(listSubWineries())

    }, [])
    return (
        <div className={`scroll-menu container-page `}>

            <TitleSVG Icon={AddList}
                titleHighlight={"Crear "}
                title={"orden de transferencia"} />

            <div
                className={`${style.subtitle}`}>
                Inventario consolidado
            </div>

            <Table style={tableStyle}>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Stock</th>
                        <th>Agregar</th>
                    </tr>
                </thead>
                <tbody
                    className={`${tableStyle.table_body}`}>
                    {
                        inventory.map(consolidateProduct => (
                            <tr key={consolidateProduct._id}>
                               
                                <td>
                                {consolidateProduct.products[0].name }
                                </td>
                                <td>

                                {consolidateProduct.stocks }

                                </td>
                                <td>
                                    <img className={`${style.plus_button} animate__animated animate__bounceIn`} onClick={() => {
                                        dispatch(setProductToTranfer(
                                            {...consolidateProduct.products[0],stocks:consolidateProduct.stocks}
                                        ))
                                        setIsShowAdd(true)
                                    }} src={plusCircle} height={30} alt="" />


                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>

            {isVisibleIconCart &&
                <div ref={saleCartRef}>
                    <div className={`${style.margin_top_20} ${style.row_vertical_center} ${style.center_container} animate__animated animate__fadeIn`}>
                        Destino:

                        <select
                            className={`input-select-style `}
                            onChange={e => {

                                setDestinyId(e.target.value)
                            }} value={destiny?._id}>

                            <option value="">Seleccione el destino</option>
                            {
                                wareHouseList.map((winery, index) => (
                                    <option key={index} value={winery._id}>{winery.name}</option>))
                            }
                            {
                                subWineriesList.map((winery, index) => (
                                    <option key={index} value={winery._id}>{winery.name}</option>))
                            }
                        </select>

                    </div>

                    <ModalMenu
                        contentButton={
                            <ButtonIcon
                                Icon={AddList}
                                isIconCircle={true}
                                text='Carrito de ventas'
                                style={buttonStyle}

                                animation="animate__animated animate__fadeIn"
                                widthCircle="5vw"
                                widthIcon="3vw"
                            />
                            // <button>Carrito de tranferencias</button>
                        }
                        contentModal={<ModalCart modalStyle={modalStyle} style={style} destiny={destinyId} />}
                        classNameContentButton={`${style.center_container}`}
                    />
                </div>
            }


            <ModalAdd
                setIsVisibleIconCart={setIsVisibleIconCart}
                style={style}
                modalStyle={modalStyle}
                isShowModal={isShowAdd} close={() => {

                    setIsShowAdd(false)

                }} />
        </div>
    )
}



const ModalAdd = ({ setIsVisibleIconCart, style, modalStyle, product, isShowModal, close }) => {

    const { itemToTranfert, tranferCart } = useSelector(state => state.tranfers)
    const dispatch = useDispatch()

    useEffect(() => {
        if (itemToTranfert.consolidateProduct?.productId) {

            const item = tranferCart.find(item => item.product.productId._id ===
                itemToTranfert.consolidateProduct.productId._id)
            if (item) {
                dispatch(setQuantityToTranfer(item.quantity))
            } else {
                dispatch(setQuantityToTranfer(0))
            }
        }

    }, [itemToTranfert.consolidateProduct])

    const divStyle = {
        display: isShowModal ? 'block' : 'none'
    };

    return <div>{itemToTranfert.consolidateProduct &&
        <div
            onClick={close}
            className="modal"
            style={divStyle}>
            <div
                onClick={e => e.stopPropagation()}
                className={`${modalStyle.modal_content}`} >
                <div className={`${modalStyle.center}`}>

                    <div className={`${modalStyle.subtitle}`}>{itemToTranfert.consolidateProduct.name}</div>
                    <div className={`${modalStyle.margin_top_10}`}>
                        <span>Cantidad: </span>

                        <Input
                            classNameInput={`${modalStyle.form_input} ${modalStyle.margin_top_10}`}
                            classNameContent={`${modalStyle.form_input__inline}`}
                            onChange={e => {

                                e.persist();
                                if (isNumeric(e.target.value) && e.target.value > 0 && e.target.value <= itemToTranfert.consolidateProduct.stocks) {
                                    dispatch(setQuantityToTranfer(e.target.value))
                                }

                            }}
                            value={itemToTranfert.quantity}
                            min={1}
                            max={itemToTranfert.consolidateProduct.stocks}
                            placeholder={"Cantidad a agregar"}
                            type={"number"}

                        />
                    </div>
                    <div className={`${modalStyle.margin_top_10}`}>
                        <button className={`btns-admin btn-create-edit ${modalStyle.button}`} onClick={close}>Cancelar</button>
                        <button className={`btns-admin btn-create-edit ${(itemToTranfert.quantity > 0) ? style.button : 'btns-admin-inactive'}`}
                            onClick={(e) => {
                                dispatch(addToTranferCart(itemToTranfert))
                                setIsVisibleIconCart(true)
                                close(e)
                            }}
                            disabled={!(itemToTranfert.quantity > 0)}>
                            Guardar
                        </button>

                    </div>
                </div>
            </div>
        </div>
    }</div>
}
export default CreateTranferWithoutOrder
const ModalCart = ({ modalStyle, style, destiny }) => {
    const history = useHistory()
    const { tranferCart } = useSelector(state => state.tranfers)
    const dispatch = useDispatch()
    return <div>
        <div className="modal-content modal-report-post" >
            <Table>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Producto</th>
                        <th>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tranferCart.map(item => (
                            <tr key={item.product._id}>
                                <td>{item.product.code}</td>
                                <td>{item.product.name}</td>
                                <td>{item.quantity}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <div className={`${modalStyle.center}`}>
                <button
                    className={`btns-admin btn-create-edit ${style.button}`}
                    disabled={!destiny || tranferCart.length === 0}
                    onClick={() => {

                        //    const order = {
                        //     _id: "xds", code: "1213312", date: "20/12/2021", sender: destiny, attendant: "attendant", ubication: "ubication", state: "state",
                        //items: tranferCart
                        //   }
                        // history.push("PendingOrders")
                        dispatch(createPendingOrders(tranferCart, destiny, history))
                        dispatch(setQuantityToTranfer(0))
                        // dispatch(setQuantityToTranfer(null))
                        // history.push("PendingOrders")
                    }}>Guardar pedido
                </button>
            </div>
        </div>
    </div>
}